import * as React from 'react';

import {DUE_UNIT_DAYS_ID} from 'nutshell-core/date-time/delays';

import {ConditionalCheckboxInput} from 'shells/form/conditional-checkbox-input';

import type {TimespanInput} from 'nutshell-graphql-types';

import {AutocloseDurationInput} from './autoclose-duration-input';

type Props = {
    autocloseDuration: TimespanInput | null | undefined;
    autocloseOutcomeId: string | null | undefined;
    onAutocloseDurationChange: (arg1?: TimespanInput | null | undefined) => void;
    onAutocloseOutcomeIdChange: (arg1?: string | null | undefined) => void;
};

export class AutocloseDurationPicker extends React.PureComponent<Props> {
    render() {
        return (
            <ConditionalCheckboxInput
                onChange={this.handleToggle}
                label='Automatically close leads if they remain in this stage for more than…'
                checked={Boolean(this.props.autocloseDuration)}
            >
                {this.props.autocloseDuration ? (
                    <AutocloseDurationInput
                        autocloseDuration={this.props.autocloseDuration}
                        autocloseOutcomeId={this.props.autocloseOutcomeId}
                        onAutocloseDurationChange={this.props.onAutocloseDurationChange}
                        onAutocloseOutcomeIdChange={this.props.onAutocloseOutcomeIdChange}
                    />
                ) : null}
            </ConditionalCheckboxInput>
        );
    }

    handleToggle = () => {
        if (this.props.autocloseDuration) {
            // If we currently have a autocloseDuration, set value to null
            this.props.onAutocloseDurationChange(null);
            this.props.onAutocloseOutcomeIdChange(null);
        } else {
            // Not currently active, so give a default value
            const defaultValue = {
                timespan: 5,
                unit: DUE_UNIT_DAYS_ID,
            } as const;

            this.props.onAutocloseDurationChange(defaultValue);
            this.props.onAutocloseOutcomeIdChange(null);
        }
    };
}
